// api/deliveries.js
import apiClient from './client';

export const deliveryApi = {
  // Get all deliveries
  getAll: () => apiClient.get('/deliveries'),
  
  // Get delivery by ID
  getById: (id) => apiClient.get(`/deliveries/${id}`),
  
  // Create delivery
  create: (data) => apiClient.post('/deliveries', data),
  
  // Update delivery
  update: (id, data) => apiClient.put(`/deliveries/${id}`, data),
  
  // Delete delivery
  delete: (id) => apiClient.delete(`/deliveries/${id}`),
  
  // Get deliveries by customer
  getByCustomer: (customerId) => apiClient.get(`/deliveries/customer/${customerId}`),
};